<div class="ks-kart-wrap">

  <!-- Başlık: kişi bilgisi -->
  <div class="ks-kart-baslik-row">
    @if (sahipResimUrl()) {
    <img class="ks-kart-avatar ks-kart-avatar-resim"
         [src]="sahipResimUrl()"
         alt="" />
    } @else {
    <div class="ks-kart-avatar">{{ sahipIsmi?.[0] || '?' }}</div>
    }
    <div class="ks-kart-kisi">
      <span class="ks-kart-isim">{{ sahipIsmi }}</span>
      @if (kartOkuyucuda()) {
      <span class="ks-kart-okuyucuda-badge">
        <span class="ks-kart-okuyucuda-nokta"></span>
        <span>Kart Okuyucuda</span>
      </span>
      <span class="ks-firmada-badge firmada">Firmada</span>
      } @else if (sahipIsmi) {
      <span class="ks-kart-sahip-badge">
        <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>
        <span>Kart Sahibi</span>
      </span>
      @if (firmadaMi() === true) {
      <span class="ks-firmada-badge firmada">Firmada</span>
      } @else if (firmadaMi() === false) {
      <span class="ks-firmada-badge disarida">Dışarıda</span>
      }
      }
      <span class="ks-kart-uid">UID: {{ kartUid }}</span>
    </div>
    <button class="ks-yenile-btn"
            (click)="yenile()"
            [class.donuyor]="yukleniyor()"
            aria-label="Yenile">
      <svg viewBox="0 0 24 24"
           width="14"
           height="14"
           fill="none"
           stroke="currentColor"
           stroke-width="2"
           stroke-linecap="round"
           stroke-linejoin="round">
        <polyline points="23 4 23 10 17 10" />
        <polyline points="1 20 1 14 7 14" />
        <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
      </svg>
    </button>
    <button class="ks-ayar-btn"
            (click)="ayarlarAc()"
            aria-label="Ayarlar"
            title="Ayarlar (hedef süre, tolerans, gruplama)">
      <svg viewBox="0 0 24 24"
           width="14"
           height="14"
           fill="none"
           stroke="currentColor"
           stroke-width="2"
           stroke-linecap="round"
           stroke-linejoin="round">
        <circle cx="12"
                cy="12"
                r="3" />
        <path
              d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />
      </svg>
    </button>
  </div>

  <!-- Ay seçici -->
  <div class="ks-ay-secici">
    <button class="ks-ay-btn"
            (click)="ayDegistir(-1)"
            aria-label="Önceki ay">
      <svg viewBox="0 0 24 24"
           width="14"
           height="14"
           fill="none"
           stroke="currentColor"
           stroke-width="2">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    </button>
    <span class="ks-ay-baslik">{{ ayBasligi }}</span>
    <button class="ks-ay-btn"
            (click)="ayDegistir(1)"
            [disabled]="buAymi"
            aria-label="Sonraki ay">
      <svg viewBox="0 0 24 24"
           width="14"
           height="14"
           fill="none"
           stroke="currentColor"
           stroke-width="2">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </button>
    <button class="ks-bugun-btn"
            (click)="ayBugune()"
            [disabled]="buAymi"
            aria-label="Bu ay"
            title="Bu aya dön">
      Bugün
    </button>
  </div>

  <!-- Ayarlar dişli butonundaki dialog'a taşındı (hedef, tolerans, gruplama) -->

  <!-- Gün listesi -->
  <!-- NOT: 'yukleniyor()' tek başına koşul olursa, websocket'ten her kart olayı
       geldiğinde ayVerisiYukle() çalışıp grid'i anlık olarak "Yükleniyor..." satırına
       indirip hemen geri genişletiyordu (liste daralıp genişliyordu). Veri zaten varsa
       (gunler().length > 0) grid DOM'da kalmalı — yenileme sessizce arka planda olsun;
       "Yükleniyor..." sadece ilk açılışta (henüz hiç veri yokken) gösterilsin. -->
  @if (yukleniyor() && gunler().length === 0) {
  <div class="ks-durum-satiri">Yükleniyor...</div>
  } @else if (gunler().length === 0) {
  <div class="ks-durum-satiri">Bu ay için okuma kaydı yok</div>
  } @else {
  @if (gunlukHedefDk() > 0 && gunler().length) {
  <div class="ks-ay-ozet">
    <span class="ks-ay-ozet-baslik">Ay özeti</span>
    <span class="ks-ay-ozet-kalem">Süre: <strong>{{ dakikaFormat(ayToplamNetDk) }}</strong></span>
    <span class="ks-ay-ozet-kalem">Gün: {{ ayCalisilanGunAdet }}</span>
    <span class="ks-ay-ozet-fazla">Fazla: +{{ dakikaFormat(ayToplamFazlaDk) }}</span>
    <span class="ks-ay-ozet-eksik">Eksik: −{{ dakikaFormat(ayToplamEksikDk) }}</span>
  </div>
  }
  <div class="ks-gun-listesi">
    @for (g of gunler(); track g.tarih) {
    <div class="ks-gun-satiri"
         [class.hafta-sonu]="g.haftaSonuMu"
         [class.tatil]="g.tatilMi"
         [class.bos]="g.sayisi === 0"
         [class.bugun]="g.bugunMu"
         (click)="gunAc(g)">
      <div class="ks-gun-ust">
        <span class="ks-gun-no">{{ g.gun }}</span>
        <span class="ks-gun-adi">{{ g.gunAdi }}</span>
        @if (g.bugunMu) { <span class="ks-bugun-rozet">Bugün</span> }
        @if (g.sayisi === 0) {
        <span class="ks-gun-bos-yazi">Hareket yok</span>
        } @else {
        <span class="ks-gun-ilk-son">
          <span class="ks-nokta ilk"></span>{{ g.ilk }}
          @if (g.ilkYuvari) { <span class="ks-yuvari"
                title="Toleransla hedef giriş saatine yuvarlandı">≈</span> }
          <span class="ks-ok">→</span>
          <span class="ks-nokta son"></span>{{ g.son }}
          @if (g.sonYuvari) { <span class="ks-yuvari"
                title="Toleransla hedef çıkış saatine yuvarlandı">≈</span> }
        </span>
        @if (cokluGirisCikisAcik() && g.segmentler.length > 1) {
        <span class="ks-gun-segment-rozet" [title]="g.segmentler.length + ' mesai bloğu'">{{ g.segmentler.length }} blok</span>
        }

        }
        @if (g.kesintiler && g.kesintiler.length) {
        <span class="ks-gun-kesinti-rozet"
              [title]="g.kesintiler.length + ' mola/izin kaydı — ' + dakikaFormat(molaToplamDk(g.kesintiler)) + ' mola düşüldü'">
          <svg viewBox="0 0 24 24"
               width="10"
               height="10"
               fill="none"
               stroke="currentColor"
               stroke-width="2.2"
               stroke-linecap="round"
               stroke-linejoin="round">
            <circle cx="12"
                    cy="12"
                    r="9" />
            <polyline points="12 7 12 12 15.5 14" />
          </svg>
        </span>
        }
        @if (gunlukHedefDk() > 0 && g.netSure && gunFazlaEksikDk(g) !== 0) {
        <span class="ks-gun-fe-rozet"
              [class.eksik]="gunFazlaEksikDk(g) < 0"
              [title]="(gunFazlaEksikDk(g) < 0 ? 'Eksik çalışma' : 'Fazla çalışma') + ' (hedef ' + dakikaFormat(gunlukHedefDk()) + '/gün)'">
          {{ gunFazlaEksikMetni(g) }}
        </span>
        }
        @if (g.aciklama) {
        <span class="ks-gun-not-rozet"
              [title]="g.aciklama">
          <svg viewBox="0 0 24 24"
               width="10"
               height="10"
               fill="none"
               stroke="currentColor"
               stroke-width="2.2"
               stroke-linecap="round"
               stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16"
                  y1="13"
                  x2="8"
                  y2="13" />
            <line x1="16"
                  y1="17"
                  x2="8"
                  y2="17" />
          </svg>
        </span>
        }
        <!-- <span class="ks-gun-sayisi">{{ g.sayisi }} okutma</span> -->
        @if (g.netSure || g.sure) {
        <span class="ks-gun-sure"
              [title]="g.netSure ? 'Net süre (mola düşülmüş)' : 'İlk-son arası fark'">{{ g.netSure || g.sure }}</span>
        }
      </div>
      <div class="ks-gun-aksiyonlar">
        <button class="ks-tatil-btn"
                [class.aktif]="g.tatilMi"
                (click)="$event.stopPropagation(); tatilToggle(g.tarih)"
                [title]="g.tatilMi ? 'Tatil işaretini kaldır' : 'Tatil olarak işaretle'">
          <svg viewBox="0 0 24 24"
               width="10"
               height="10"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               stroke-linecap="round"
               stroke-linejoin="round">
            <circle cx="12"
                    cy="12"
                    r="5" />
            <line x1="12"
                  y1="1"
                  x2="12"
                  y2="3" />
            <line x1="12"
                  y1="21"
                  x2="12"
                  y2="23" />
            <line x1="4.22"
                  y1="4.22"
                  x2="5.64"
                  y2="5.64" />
            <line x1="18.36"
                  y1="18.36"
                  x2="19.78"
                  y2="19.78" />
            <line x1="1"
                  y1="12"
                  x2="3"
                  y2="12" />
            <line x1="21"
                  y1="12"
                  x2="23"
                  y2="12" />
            <line x1="4.22"
                  y1="19.78"
                  x2="5.64"
                  y2="18.36" />
            <line x1="18.36"
                  y1="5.64"
                  x2="19.78"
                  y2="4.22" />
          </svg>
        </button>

        @if (gunSilinebilirMi(g)) {
        <button class="ks-tatil-btn ks-gun-sil-satir-btn"
                nz-popconfirm
                [nzPopconfirmTitle]="'Bu güne ait ' + g.sayisi + ' hareketin TAMAMINI silmek istediğinize emin misiniz? Bu işlem geri alınamaz.'"
                nzOkText="Günü Sil"
                nzCancelText="Vazgeç"
                nzPopconfirmPlacement="top"
                [disabled]="gunSilKaydediliyor()"
                (nzOnConfirm)="gunuSil(g)"
                (click)="$event.stopPropagation()"
                title="Bu güne ait tüm hareketleri sil">
          <svg viewBox="0 0 24 24"
               width="10"
               height="10"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               stroke-linecap="round"
               stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
          </svg>
        </button>
        }
      </div>

      <svg class="ks-gun-git"
           viewBox="0 0 24 24"
           width="13"
           height="13"
           fill="none"
           stroke="currentColor"
           stroke-width="2">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </div>
    }
  </div>
  }


  <!-- Gün Detay Dialog — her zaman DOM'da (document.body'e taşınıyor), sadece içerik @if ile kontrol ediliyor -->
  <div class="ks-dialog-arkaplan"
       [class.ks-dialog-acik]="!!dialogGun()"
       (click)="dialogKapat()"
       #dialogOverlay>
    @if (dialogGun(); as gun) {
    <div class="ks-dialog"
         (click)="$event.stopPropagation()">
      <div class="ks-dialog-baslik">
        @if (sahipResimUrl()) {
        <img class="ks-dialog-avatar ks-dialog-avatar-resim"
             [src]="sahipResimUrl()"
             alt="" />
        } @else {
        <div class="ks-dialog-avatar">{{ sahipIsmi?.[0] || '?' }}</div>
        }
        <div class="ks-dialog-baslik-metin">
          <span class="ks-dialog-isim">{{ sahipIsmi }}</span>
          <span class="ks-dialog-tarih">{{ gunTarihUzun(gun.tarih) }}</span>
        </div>
        <button class="ks-dialog-tatil-btn"
                [class.aktif]="gun.tatilMi"
                [disabled]="tatilKaydediliyor()"
                (click)="tatilToggle(gun.tarih)"
                [title]="gun.tatilMi ? 'Tatil işaretini kaldır' : 'Tatil olarak işaretle'">
          <svg viewBox="0 0 24 24"
               width="13"
               height="13"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               stroke-linecap="round"
               stroke-linejoin="round">
            <circle cx="12"
                    cy="12"
                    r="5" />
            <line x1="12"
                  y1="1"
                  x2="12"
                  y2="3" />
            <line x1="12"
                  y1="21"
                  x2="12"
                  y2="23" />
            <line x1="4.22"
                  y1="4.22"
                  x2="5.64"
                  y2="5.64" />
            <line x1="18.36"
                  y1="18.36"
                  x2="19.78"
                  y2="19.78" />
            <line x1="1"
                  y1="12"
                  x2="3"
                  y2="12" />
            <line x1="21"
                  y1="12"
                  x2="23"
                  y2="12" />
            <line x1="4.22"
                  y1="19.78"
                  x2="5.64"
                  y2="18.36" />
            <line x1="18.36"
                  y1="5.64"
                  x2="19.78"
                  y2="4.22" />
          </svg>
          {{ tatilKaydediliyor() ? '...' : (gun.tatilMi ? 'Tatil' : 'Tatil değil') }}
        </button>
        <button class="ks-dialog-kapat"
                (click)="dialogKapat()"
                aria-label="Kapat">
          <svg viewBox="0 0 24 24"
               width="16"
               height="16"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               stroke-linecap="round">
            <line x1="18"
                  y1="6"
                  x2="6"
                  y2="18" />
            <line x1="6"
                  y1="6"
                  x2="18"
                  y2="18" />
          </svg>
        </button>
      </div>

      @if (gun.sayisi > 0) {
      <div class="ks-dialog-ozet">
        @if (cokluGirisCikisAcik() && gun.segmentler.length) {
        <div class="ks-segment-liste">
          @for (s of gun.segmentler; track $index) {
          <div class="ks-segment-satir">
            <span class="ks-nokta ilk"></span>{{ s.giris }}
            @if (s.girisYuvari) { <span class="ks-yuvari" title="Toleransla hedef giriş saatine yuvarlandı">≈</span> }
            <span class="ks-ok">→</span>
            @if (s.acikMi) {
            <span class="ks-segment-acik">henüz çıkmadı</span>
            } @else {
            <span class="ks-nokta son"></span>{{ s.cikis }}
            @if (s.cikisYuvari) { <span class="ks-yuvari" title="Toleransla hedef çıkış saatine yuvarlandı">≈</span> }
            <span class="ks-segment-sure">{{ s.sure }}</span>
            }
          </div>
          }
        </div>
        } @else {
        <span><span class="ks-nokta ilk"></span> {{ gun.ilk }}</span>
        @if (gun.son && gun.son !== gun.ilk) {
        <span class="ks-ok">→</span>
        <span><span class="ks-nokta son"></span> {{ gun.son }}</span>
        }
        }
        @if (gun.netSure || gun.sure) {
        <span class="ks-dialog-ozet-sure"
              [title]="gun.netSure ? 'Net süre (kesintiler düşülmüş)' : 'İlk-son arası fark'">{{ gun.netSure || gun.sure
          }}</span>
        }
        <!-- <span class="ks-dialog-ozet-sayi">{{ gun.sayisi }} okutma</span> -->
      </div>
      }

      @if (gun.sayisi > 0 && gun.kesintiler && gun.kesintiler.length) {
      <div class="ks-kesinti-ozet ks-kesinti-ozet-ust">
        <span>Toplam: {{ dakikaFormat(sureToDakika(gun.sure)) }}</span>
        <span>Kesinti: {{ dakikaFormat(molaToplamDk(gun.kesintiler)) }}</span>
        <span class="ks-kesinti-ozet-net">Net: {{ gun.netSure || dakikaFormat(sureToDakika(gun.sure)) }}</span>
      </div>
      }

      <div class="ks-dialog-liste">
        @if (gun.sayisi === 0) {
        <div class="ks-dialog-bos">Bu gün için hareket yok</div>
        }
        @for (grup of okutmaGruplari(gun.olaylar); track grup.ilkOlay._id || grup.ilkOlay.zaman) {

        <!-- Grup düzenleme modu -->
        @if (grup.ilkOlay._id && duzenlenenGrupIlkId() === grup.ilkOlay._id) {
        <div class="ks-dialog-satir ks-grup-duzenle-satir">
          <input class="ks-manuel-input ks-grup-duzenle-time" type="time"
                       [ngModel]="duzenleGrupIlkSaat()" (ngModelChange)="duzenleGrupIlkSaat.set($event)" />
          <button class="ks-dialog-sil-btn"
                  (click)="grupDuzenleKapat()"
                  aria-label="Vazgeç"
                  title="Vazgeç">
            <svg viewBox="0 0 24 24"
                 width="13"
                 height="13"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="2"
                 stroke-linecap="round">
              <line x1="18"
                    y1="6"
                    x2="6"
                    y2="18" />
              <line x1="6"
                    y1="6"
                    x2="18"
                    y2="18" />
            </svg>
          </button>
          <button class="ks-dialog-sil-btn ks-dialog-onay-btn"
                  [disabled]="duzenleGrupKaydediliyor()"
                  (click)="grupDuzenleKaydet(grup)"
                  aria-label="Kaydet"
                  title="Kaydet">
            <svg viewBox="0 0 24 24"
                 width="13"
                 height="13"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="2"
                 stroke-linecap="round"
                 stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </button>
        </div>

        } @else {
        <!-- Grup görünüm modu -->
        <div class="ks-dialog-satir ks-dialog-satir-grup"
             [class.grup-tekil]="!grup.grupMu"
             [class.grup-coklu]="grup.grupMu">

          <div class="ks-dialog-satir-sol">
            @if (grup.grupMu) {
            <span class="ks-dialog-grup-rozet"
                  [title]="grup.tumOlaylar.length + ' okutma bu grupta'">×{{ grup.tumOlaylar.length }}</span>
            } @else if (grup.ilkOlay.manuel || grup.sonOlay.manuel) {
            <span class="ks-dialog-manuel-rozet">Manuel</span>
            }

            <!-- @if (!grup.sonOlay.manuel) {
                    <i class="address blue card icon"></i>
                  } -->
          </div>

          <span class="ks-dialog-saat">{{ saatFormat(grup.ilkOlay.zaman) }}</span>

          @if (grup.ilkOlay.manuel || grup.sonOlay.manuel || superYoneticiMi) {
          <div class="ks-dialog-satir-aksiyonlar">
            <button class="ks-dialog-sil-btn"
                    (click)="grupDuzenleAc(grup)"
                    aria-label="Grubu düzenle"
                    title="Okutma zamanını düzenle">
              <svg viewBox="0 0 24 24"
                   width="15"
                   height="15"
                   fill="none"
                   stroke="currentColor"
                   stroke-width="2"
                   stroke-linecap="round"
                   stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </button>
            <button class="ks-dialog-sil-btn"
                    nz-popconfirm
                    [nzPopconfirmTitle]="grup.grupMu ? 'Bu gruptaki ' + grup.tumOlaylar.length + ' kaydı silmek istediğinize emin misiniz?' : 'Bu kaydı silmek istediğinize emin misiniz?'"
                    nzOkText="Sil"
                    nzCancelText="Vazgeç"
                    nzPopconfirmPlacement="top"
                    (nzOnConfirm)="grupSil(grup)"
                    (click)="$event.stopPropagation()"
                    [title]="grup.grupMu ? 'Grubu sil (' + grup.tumOlaylar.length + ')' : 'Kaydı sil'">
              <svg viewBox="0 0 24 24"
                   width="15"
                   height="15"
                   fill="none"
                   stroke="currentColor"
                   stroke-width="2"
                   stroke-linecap="round"
                   stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
              </svg>
            </button>
          </div>
          }
        </div>
        }
        }
      </div>

      <!-- Mola/İzin tetikleyicisi — kompakt özet, tıklanınca ayrı dialog açılır -->
      <button class="ks-mola-tetikleyici" (click)="molaAc()">
        <span class="ks-mola-tetikleyici-baslik">Mola / İzin</span>
        @if (gun.kesintiler && gun.kesintiler.length) {
        <span class="ks-mola-tetikleyici-rozet">{{ gun.kesintiler.length }} kayıt · −{{ dakikaFormat(molaToplamDk(gun.kesintiler)) }}</span>
        } @else {
        <span class="ks-mola-tetikleyici-bos">Yok</span>
        }
        <svg class="ks-mola-tetikleyici-ok" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>

      <!-- Mola / İzin (kesinti) yönetimi — ayrı dialog olarak açılır -->
      <div class="ks-kesinti-blok"
           [class.ks-kesinti-acik]="molaDialogAcik()"
           (click)="molaKapat()">
        <div class="ks-kesinti-panel" (click)="$event.stopPropagation()">
        <div class="ks-kesinti-baslik-row">
          <span class="ks-kesinti-baslik">Mola / İzin</span>
          @if (!kesintiFormAcik()) {
          <button class="ks-kesinti-ekle-btn"
                  (click)="kesintiFormAc()"
                  aria-label="Mola/izin ekle">
            <svg viewBox="0 0 24 24"
                 width="12"
                 height="12"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="2"
                 stroke-linecap="round">
              <line x1="12"
                    y1="5"
                    x2="12"
                    y2="19" />
              <line x1="5"
                    y1="12"
                    x2="19"
                    y2="12" />
            </svg>
            Ekle
          </button>
          }
          <button class="ks-dialog-sil-btn ks-mola-kapat-btn"
                  (click)="molaKapat()"
                  aria-label="Kapat"
                  title="Kapat">
            <svg viewBox="0 0 24 24"
                 width="14"
                 height="14"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="2"
                 stroke-linecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        @if (!kesintiFormAcik()) {
        <div class="ks-kesinti-sablonlar">
          @for (s of kesintiSablonlari; track s.id) {
          <button class="ks-sablon-btn"
                  [class.ekli]="kesintiSablonMevcut(s)"
                  [disabled]="kesintiKaydediliyor()"
                  (click)="kesintiSablonToggle(s)"
                  [title]="kesintiSablonMevcut(s) ? (s.ad + ' kaydını kaldır') : (s.ad + ': ' + s.baslangic + '–' + s.bitis + ' ekle')">
            @if (kesintiSablonMevcut(s)) {
            <svg viewBox="0 0 24 24"
                 width="11"
                 height="11"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="2.4"
                 stroke-linecap="round"
                 stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <svg class="ks-sablon-x"
                 viewBox="0 0 24 24"
                 width="9"
                 height="9"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="2.6"
                 stroke-linecap="round">
              <line x1="18"
                    y1="6"
                    x2="6"
                    y2="18" />
              <line x1="6"
                    y1="6"
                    x2="18"
                    y2="18" />
            </svg>
            } @else {
            <svg viewBox="0 0 24 24"
                 width="11"
                 height="11"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="2.4"
                 stroke-linecap="round">
              <line x1="12"
                    y1="5"
                    x2="12"
                    y2="19" />
              <line x1="5"
                    y1="12"
                    x2="19"
                    y2="12" />
            </svg>
            }
            {{ s.ad }}
            <span class="ks-sablon-saat">{{ s.baslangic }}–{{ s.bitis }}</span>
          </button>
          }
        </div>
        }

        @if (gun.kesintiler && gun.kesintiler.length) {
        <div class="ks-kesinti-liste">
          @for (k of gun.kesintiler; track k._id) {
          @if (k._id && duzenlenenKesintiId() === k._id) {
          <!-- Düzenleme satırı -->
          <div class="ks-dialog-satir ks-kesinti-duzenle-satir">
            <div class="ks-kesinti-duzenle-ust">
              <select class="ks-manuel-select"
                      [ngModel]="kesintiTur()"
                      (ngModelChange)="kesintiTur.set($event)">
                <option value="mola">Mola</option>
                <option value="izin">İzin</option>
              </select>
              <input class="ks-manuel-input" type="time"
                             [ngModel]="kesintiBaslangic()" (ngModelChange)="kesintiBaslangic.set($event)" />
              <input class="ks-manuel-input" type="time"
                             [ngModel]="kesintiBitis()" (ngModelChange)="kesintiBitis.set($event)" />
              <button class="ks-dialog-sil-btn"
                      (click)="kesintiFormKapat()"
                      aria-label="Vazgeç"
                      title="Vazgeç">
                <svg viewBox="0 0 24 24"
                     width="13"
                     height="13"
                     fill="none"
                     stroke="currentColor"
                     stroke-width="2"
                     stroke-linecap="round">
                  <line x1="18"
                        y1="6"
                        x2="6"
                        y2="18" />
                  <line x1="6"
                        y1="6"
                        x2="18"
                        y2="18" />
                </svg>
              </button>
              <button class="ks-dialog-sil-btn ks-dialog-onay-btn"
                      [disabled]="kesintiKaydediliyor()"
                      (click)="kesintiDuzenleKaydet()"
                      aria-label="Kaydet"
                      title="Kaydet">
                <svg viewBox="0 0 24 24"
                     width="13"
                     height="13"
                     fill="none"
                     stroke="currentColor"
                     stroke-width="2"
                     stroke-linecap="round"
                     stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </button>
            </div>
            <input class="ks-manuel-input ks-kesinti-aciklama-input" type="text" placeholder="Açıklama (opsiyonel)"
                           [ngModel]="kesintiAciklama()" (ngModelChange)="kesintiAciklama.set($event)" />
          </div>
          } @else {
          <!-- Görünüm satırı -->
          <div class="ks-dialog-satir ks-kesinti-satir"
               [class.mola]="k.tur === 'mola'"
               [class.izin]="k.tur === 'izin'">
            <span class="ks-kesinti-rozet"
                  [class.mola]="k.tur === 'mola'"
                  [class.izin]="k.tur === 'izin'">
              {{ k.tur === 'mola' ? 'Mola' : 'İzin' }}
            </span>
            <span class="ks-dialog-saat">{{ k.baslangic }}–{{ k.bitis }}</span>
            <span class="ks-kesinti-sure">{{ dakikaFormat(kesintiSureDk(k)) }}</span>
            @if (k.aciklama) {
            <span class="ks-kesinti-not"
                  [title]="k.aciklama">{{ k.aciklama }}</span>
            }
            <button class="ks-dialog-sil-btn"
                    (click)="kesintiDuzenleAc(k)"
                    aria-label="Düzenle"
                    title="Düzenle">
              <svg viewBox="0 0 24 24"
                   width="13"
                   height="13"
                   fill="none"
                   stroke="currentColor"
                   stroke-width="2"
                   stroke-linecap="round"
                   stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </button>
            <button class="ks-dialog-sil-btn"
                    nz-popconfirm
                    nzPopconfirmTitle="Bu kaydı silmek istediğinize emin misiniz?"
                    nzOkText="Sil"
                    nzCancelText="Vazgeç"
                    nzPopconfirmPlacement="top"
                    (nzOnConfirm)="kesintiSil(k._id)"
                    (click)="$event.stopPropagation()"
                    title="Sil">
              <svg viewBox="0 0 24 24"
                   width="13"
                   height="13"
                   fill="none"
                   stroke="currentColor"
                   stroke-width="2"
                   stroke-linecap="round"
                   stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
              </svg>
            </button>
          </div>
          }
          }
        </div>
        }

        @if (kesintiFormAcik() && !duzenlenenKesintiId()) {
        <div class="ks-manuel-form ks-kesinti-form">
          <div class="ks-manuel-form-satir">
            <select class="ks-manuel-select"
                    [ngModel]="kesintiTur()"
                    (ngModelChange)="kesintiTur.set($event)">
              <option value="mola">Mola</option>
              <option value="izin">İzin</option>
            </select>
            <input class="ks-manuel-input" type="time"
                       [ngModel]="kesintiBaslangic()" (ngModelChange)="kesintiBaslangic.set($event)" />
            <input class="ks-manuel-input" type="time"
                       [ngModel]="kesintiBitis()" (ngModelChange)="kesintiBitis.set($event)" />
          </div>
          <div class="ks-manuel-form-satir ks-manuel-form-aksiyonlar">
            <button class="ks-manuel-iptal-btn"
                    (click)="kesintiFormKapat()">İptal</button>
            <button class="ks-manuel-kaydet-btn"
                    [disabled]="kesintiKaydediliyor()"
                    (click)="kesintiEkle()">
              {{ kesintiKaydediliyor() ? 'Kaydediliyor...' : 'Kaydet' }}
            </button>
          </div>
        </div>
        }

        @if (gun.sayisi > 0 && gun.kesintiler && gun.kesintiler.length) {
        <div class="ks-kesinti-ozet">
          <span>Toplam: {{ dakikaFormat(sureToDakika(gun.sure)) }}</span>
          <span>Kesinti: {{ dakikaFormat(molaToplamDk(gun.kesintiler)) }}</span>
          <span class="ks-kesinti-ozet-net">Net: {{ gun.netSure || dakikaFormat(sureToDakika(gun.sure)) }}</span>
        </div>
        }
        </div>
      </div>

      <!-- Gün açıklaması -->
      <div class="ks-aciklama-blok">
        <textarea class="ks-aciklama-input"
                  placeholder="Açıklama ekle..."
                  rows="2"
                  [ngModel]="aciklamaDraft()"
                  (ngModelChange)="aciklamaDraft.set($event)"
                  (blur)="aciklamaKaydet(gun.tarih)"></textarea>
        @if (aciklamaKaydediliyor()) {
        <span class="ks-aciklama-kaydediliyor">Kaydediliyor...</span>
        }
      </div>

      <!-- Manuel kayıt ekleme -->
      <div class="ks-manuel-blok">
        @if (!manuelFormAcik()) {
        <div class="ks-manuel-blok-satir">
        <button class="ks-manuel-ac-btn"
                (click)="manuelFormAc(gun)">
          <svg viewBox="0 0 24 24"
               width="13"
               height="13"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               stroke-linecap="round">
            <line x1="12"
                  y1="5"
                  x2="12"
                  y2="19" />
            <line x1="5"
                  y1="12"
                  x2="19"
                  y2="12" />
          </svg>
          Manuel kayıt ekle
        </button>
        @if (girisHedefSaat() && cikisHedefSaat()) {
        <button class="ks-manuel-ac-btn ks-normal-calisma-btn"
                [disabled]="normalCalismaKaydediliyor()"
                (click)="normalCalismaEkle(gun)"
                [title]="'Giriş ' + girisHedefSaat() + ', çıkış ' + cikisHedefSaat() + ' olarak ekler ve mola şablonlarını uygular'">
          <svg viewBox="0 0 24 24"
               width="13"
               height="13"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               stroke-linecap="round"
               stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          {{ normalCalismaKaydediliyor() ? 'Ekleniyor...' : 'Normal çalışıldı' }}
        </button>
        }
        </div>
        } @else {
        <div class="ks-manuel-form">
          <div class="ks-manuel-form-satir">
            <input class="ks-manuel-input" type="date"
                       [ngModel]="manuelTarih()" (ngModelChange)="manuelTarih.set($event)" />
            <input class="ks-manuel-input" type="time"
                       [ngModel]="manuelSaat()" (ngModelChange)="manuelSaat.set($event)" />
          </div>
          <div class="ks-manuel-form-satir ks-manuel-form-aksiyonlar">
            <button class="ks-manuel-iptal-btn"
                    (click)="manuelFormKapat()">İptal</button>
            <button class="ks-manuel-kaydet-btn"
                    [disabled]="manuelKaydediliyor()"
                    (click)="manuelKaydet()">
              {{ manuelKaydediliyor() ? 'Kaydediliyor...' : 'Kaydet' }}
            </button>
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <!-- Ayarlar Dialog — dişli butonuyla açılır (document.body'e taşınıyor) -->
  <div class="ks-dialog-arkaplan"
       [class.ks-dialog-acik]="ayarDialogAcik()"
       (click)="ayarlarKapat()"
       #ayarDialogOverlay>
    @if (ayarDialogAcik()) {
    <div class="ks-dialog ks-ayarlar-dialog"
         (click)="$event.stopPropagation()">
      <div class="ks-dialog-baslik">
        <div class="ks-dialog-baslik-metin">
          <span class="ks-dialog-isim">Ayarlar</span>
          <span class="ks-dialog-tarih">Hedef süre, tolerans ve gruplama</span>
        </div>
        <button class="ks-dialog-kapat"
                (click)="ayarlarKapat()"
                aria-label="Kapat">
          <svg viewBox="0 0 24 24"
               width="16"
               height="16"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               stroke-linecap="round">
            <line x1="18"
                  y1="6"
                  x2="6"
                  y2="18" />
            <line x1="6"
                  y1="6"
                  x2="18"
                  y2="18" />
          </svg>
        </button>
      </div>

      <div class="ks-ayarlar-icerik">
        <!-- Günlük hedef süre -->
        <div class="ks-ayarlar-bolum">
          <span class="ks-ayarlar-bolum-baslik">Günlük hedef süre</span>
          <div class="ks-hedef-satir">
            <input class="ks-hedef-input" type="time"
                     [ngModel]="gunlukHedefSaat()"
                     (ngModelChange)="hedefDegistir($event)"
                     title="Günlük standart çalışma süresi — buna göre fazla/eksik çalışma hesaplanır; boş bırakılırsa hesap kapalı" />
              @if (gunlukHedefDk() > 0) {
            <span class="ks-hedef-aciklama ks-hedef-aciklama-acik">Fazla/eksik hesabı açık</span>
            } @else {
            <span class="ks-hedef-aciklama">Hesap için hedef süre girin</span>
            }
          </div>
        </div>

        <!-- Giriş/çıkış toleransı -->
        <div class="ks-ayarlar-bolum">
          <span class="ks-ayarlar-bolum-baslik">Tolerans (okunanlar için)</span>
          <div class="ks-tolerans-satir">
            <label class="ks-tolerans-etiket">Giriş hedefi</label>
            <input class="ks-tolerans-input" type="time"
                     [ngModel]="girisHedefSaat()"
                     (ngModelChange)="girisHedefDegistir($event)"
                     title="Hedef giriş saati — buna tolerans dahilinde yuvarlanır" />
          </div>
          <div class="ks-tolerans-satir">
            <label class="ks-tolerans-etiket">Çıkış hedefi</label>
            <input class="ks-tolerans-input" type="time"
                     [ngModel]="cikisHedefSaat()"
                     (ngModelChange)="cikisHedefDegistir($event)"
                     title="Hedef çıkış saati — buna tolerans dahilinde yuvarlanır" />
          </div>
          <div class="ks-tolerans-satir">
            <label class="ks-tolerans-etiket">Tolerans</label>
            <input class="ks-tolerans-input ks-tolerans-dk" type="number" min="0" max="120" step="1"
                     [ngModel]="toleransDk()"
                     (ngModelChange)="toleransDegistir($event)"
                     title="Hedef saatten ± bu kadar dakika içindeki okumalar yuvarlanır" />
            <span class="ks-tolerans-birim">dk</span>
          </div>
          <div class="ks-tolerans-not">Manuel girilen kayıtlar yuvarlanmaz.</div>
        </div>

        <!-- Okutma gruplama -->
        <div class="ks-ayarlar-bolum">
          <span class="ks-ayarlar-bolum-baslik">Okutma gruplama</span>
          <label class="ks-grup-secenek"
                 title="Belirlenen süre içindeki okutmaları grupla; grubun ilki giriş, sonu çıkış sayılır">
            <input type="checkbox" [ngModel]="grupOkutmaAcik()" (ngModelChange)="grupToggle($event)" />
              Okutmaları grupla
          </label>
          @if (grupOkutmaAcik()) {
          <div class="ks-grup-esik-satir">
            <span class="ks-grup-esik-etiket">Eşik:</span>
            <input class="ks-grup-esik-input" type="number" min="1" max="3600" step="1"
                       [ngModel]="grupEsikSaniye()"
                       (ngModelChange)="grupAyariniKaydet($event)"
                       title="Aralarındaki süre bu değerden az olan okutmalar aynı gruba dahil edilir" />
            <span class="ks-grup-esik-birim">sn</span>
          </div>
          }
        </div>

        <!-- Giriş/Çıkış modu -->
        <div class="ks-ayarlar-bolum">
          <span class="ks-ayarlar-bolum-baslik">Giriş/Çıkış modu</span>
          <label class="ks-grup-secenek"
                 title="Açıksa: günün (eşiklenmiş) okutmaları sırayla giriş-çıkış-giriş-çıkış... sayılır (izin/mola sonrası dönüşler dahil, gün içinde birden fazla mesai bloğu). Kapalıysa: sadece ilk okutma giriş, son okutma çıkış sayılır.">
            <input type="checkbox" [ngModel]="cokluGirisCikisAcik()" (ngModelChange)="cokluGirisCikisDegistir($event)" />
              Çoklu giriş/çıkış (gün içinde birden fazla mesai bloğu)
          </label>
        </div>
      </div>
    </div>
    }
  </div>

</div>